<app-lightweight-user-avatar
  *ngIf="showAvatar; else iconOnly"
  [isUser]="isUser"
  [profileImage]="profileImage"
  [userRole]="userRole"
  [userEmail]="userEmail"
  [userName]="userName"
  [width]="avatarWidth"
  [showBadge]="showBadge"
  [badgeIconConfig]="iconConfig"
></app-lightweight-user-avatar>

<ng-template #iconOnly>
  <span
    *ngIf="iconConfig"
    class="icon-container"
    [style.--avatar-icon-container-size]="avatarWidth ? avatarWidth + 'px' : null"
  >
    <app-pencil-icon
      [name]="iconConfig.name"
      [type]="iconConfig.type"
      [outlined]="iconConfig.outlined ?? false"
    ></app-pencil-icon>
  </span>
</ng-template>
